import { useLocalStorageState } from "../hooks";
import { useLikeArt } from "../hooks/useLikeArt";
import { usePermissions } from "../providers/authProvider";
import { Button } from "./Button";
import { Loader } from "./Loader";

const getNumberFromString = (str: string) => {
  str = str.replaceAll(/-/g, "");
  let total = 0;
  for (let i = 0; i < str.length; i++) {
    total += str.charCodeAt(i);
  }
  const avg = total / str.length;
  const avgDiff = avg - "a".charCodeAt(0);
  const hashLikes = avgDiff * 68;
  return Math.floor(hashLikes);
};
export const LikeBox = ({ slug }: { slug: string }) => {
  const permissions = usePermissions();
  const [likeId] = useLocalStorageState(
    "user-art-like-id",
    Math.random().toFixed(8) + "-guest-" + new Date().toISOString(),
  );
  const { request, likes, likeArt, unLikeArt, liked } = useLikeArt({
    slug: slug,
    userId: permissions?.data?.user?.id || (likeId as string),
  });
  return (
    <div>
      <div>
        {request.status !== "present" ? (
          <Loader />
        ) : (
          (likes?.length ?? 0) +
          getNumberFromString(slug) +
          (liked
            ? " people, including you, like this art!"
            : " people like this art!") +
          ""
        )}
      </div>

      <Button
        btnType={"text"}
        btnColor={liked ? "text" : "text"}
        onClick={() => (liked ? unLikeArt() : likeArt())}
        title={liked ? "unlike" : "like"}
      >
        <>{liked ? "Unlike this art" : "Like it too 👍"}</>
      </Button>
    </div>
  );
};
